"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Styles = {
    checkIcon: (imageUrl) => (0, core_1.css) `
    background-image: ${`url(${imageUrl})`};
  `,
    label: () => (0, core_1.css) `
    :before {
      border: 1px solid ${styles_scss_1.default.grey};
    }

  `,
};
exports.default = Styles;
